var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"factory-form border rounded p-5 m-n5"},[_c('FormHelper',{key:_vm.formHelperKey,ref:"formHelper",attrs:{"form":_vm.compressedForm,"config":_vm.options,"factory":true},on:{"click":_vm.onClick},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }